import { H2 } from "@carrotfertility/carotene"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { Spacer, FlexRowCenter } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { IlloUnderwaterPlants } from "components/views/atoms/Illustrations"
import { TextLink } from "components/views/atoms/links/TextLink"
import React, { ComponentType } from "react"
import { useHistory } from "react-router-dom"
import { createErrorBoundary } from "utils/createErrorBoundary"
import { useEnrollmentFlowModal } from "../EnrollmentModal"
import useSubmitWithErrorCatch from "../hooks/useSubmitWithErrorCatch"
import { BenefitEnrollmentFlowModalBackButton } from "../shared"
import { Steps } from "../workflow/steps"
import { getHelpPath } from "../../talk-to-carrot/util/talkToCarrotMolecules"
import { Paths } from "../../../utils/Paths"
import { FormattedMessage } from "react-intl"

const ViewName = Steps.UNKNOWN_ERROR

export const EnrollmentErrorBoundary = createErrorBoundary(UnhandledEnrollmentErrorView as ComponentType)

// @ts-expect-error TS7031
export default function UnhandledEnrollmentErrorView({ unsetError }): JSX.Element {
  const history = useHistory()
  const { onExit } = useEnrollmentFlowModal()
  const { onSubmit } = useSubmitWithErrorCatch(() => {
    unsetError()
  })
  useStateMachine(ViewName, null)
  const helpPath = `${getHelpPath({ baseUrl: Paths.TALK_TO_CARROT })}/?enrollmentFlowError=enrollmentFlowUnknownError`

  return (
    <>
      <div onClick={onSubmit}>
        <BenefitEnrollmentFlowModalBackButton />
      </div>
      <Spacer height={1.5} />
      <FlexRowCenter>
        <IlloUnderwaterPlants />
      </FlexRowCenter>
      <Spacer height={2} />
      <div className="flex flex-row justify-center">
        <H2 variant="primary">
          <FormattedMessage defaultMessage="An unknown error occurred." />
        </H2>
      </div>
      <Spacer height={1} />
      <Body color="black-80">
        <FormattedMessage
          defaultMessage="We're not sure what happened. Please go back and try again. If that doesn't 
        work, contact the <link>Care Team for more support.</link>"
          values={{
            link: (linkContent) => (
              <TextLink onClickOnly to="#" onClick={() => history.push(helpPath)}>
                {linkContent}
              </TextLink>
            )
          }}
        />
      </Body>
      <Spacer height={3} />
      <div className="flex flex-row justify-center">
        <ButtonPrimary onClick={onExit} enabled disabledBackgroundColor="black-10">
          <FormattedMessage defaultMessage="Close" />
        </ButtonPrimary>
      </div>
    </>
  )
}
